import React, { useState } from "react";
import userStore from "../zustand/userStore";
import Popup from "../features/EventOrganiser/Popup";
import { useNavigate, useLocation } from "react-router-dom";
import { getuserIdByPhoneNumber } from "../features/ticketing-app/redux/ticketingSlice";
import { useDispatch } from "react-redux";

const Footer = ({ userData: propUserData }) => {
  const storeUserData = userStore((state) => state.user);
  const userData = (propUserData && Object.keys(propUserData).length > 0) ? propUserData : storeUserData;
  const isLoggedIn = !!(userData && (userData?.id || userData?.admin_id || userData?.email_id || userData?.token));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [data, setData] = useState({
    showPopUp: false,
    option: "",
    contactNumber: "",
  });

  const currentPath = location?.pathname || "";
  let pricingHref = "/Pricing";
  if (currentPath.includes("tutor")) {
    pricingHref = "/tutor/pricing";
  } else if (currentPath.includes("coaching")) {
    pricingHref = "/coaching/pricing";
  }

  const handlePricingClick = (e) => {
    e.preventDefault();
    navigate(pricingHref);
  };
  const handleClick = () => {
    console.log("userData:", userData); // ← check this
    if (userData && (userData?.admin_id || userData?.id)) {
      navigate("/viewTickets");
    } else {
      openRegisterPopup();
    }
  };
  const openRegisterPopup = () => {
    setData({
      showPopUp: true,
      option: "",
      contactNumber: "",
    });
  };
  const buttonStyle = {
    padding: "8px 20px",
    borderRadius: "6px",
    border: "none",
    backgroundColor: "#1976d2",
    color: "#fff",
    cursor: "pointer",
  };
  return (
    <>
      <style>{`
  /* --- FOOTER SPECIFIC FIXES --- */
  .bg-footer {
    padding: 6px 15px;
    background-color: #eff1f1;
  }

  footer.bg-footer {
    width: 100%;
    overflow-x: hidden;
  }

  /* Remove extra white space in mobile */
  @media (max-width: 991px) {
    .bg-footer {
      padding: 8px 5px !important;
      margin-bottom: 0 !important;
    }

    section.text-center.py-4.px-4 {
      padding-top: 0.3rem !important;
      padding-bottom: 0.3rem !important;
      margin-bottom: 0 !important;
    }

    .landing-footer-section {
      margin-top: 0.5rem !important;
      margin-bottom: 0 !important;
      padding-bottom: 0 !important;
    }
  }

  .social-icons-container { 
    display: flex !important; 
    justify-content: center !important; 
    align-items: center !important; 
    gap: 15px !important; 
    margin-top: 15px; 
    flex-direction: row !important;
  }

  .footer-link {
    display: inline-block;
    transition: transform 0.2s ease;
    text-decoration: none;
    line-height: 0;
  }

  .footer-link:hover { 
    transform: scale(1.1); 
  }

  /* STRICTLY FORCE IMAGE SIZE */
  .footer-link img { 
    width: 24px !important; 
    height: 24px !important; 
    max-width: 24px !important; 
    max-height: 24px !important;
    object-fit: contain !important;
    display: block !important;
    margin: 0 !important;
  }

  /* --- FOOTER DESKTOP (WEB VIEW ONLY - 992px and above) --- */
  @media (min-width: 992px) {
    .landing-footer-section {
      padding: 4px 10px !important;
    }

    .landing-footer-section .bg-footer {
      padding: 4px 10px !important;
    }

    .footer-container-flex {
      display: flex !important;
      flex-direction: row !important;
      flex-wrap: nowrap !important;
      justify-content: center !important;
      align-items: center !important;
      gap: 15px !important;
      width: 100% !important;
    }

    .footer-nav {
      display: flex !important;
      flex-direction: row !important;
      align-items: center !important;
      gap: 5px !important;
      margin-bottom: 0 !important;
      width: auto !important;
      white-space: nowrap !important;
    }

    .footer-nav a {
      font-size: 15px !important;
      font-weight: 500 !important;
    }

    .landing-footer-section .footer-nav a {
      font-size: 15px !important;
      padding: 2px 8px !important;
      line-height: 1.2 !important;
      min-height: 24px !important;
    }

    .social-icons-container {
      display: flex !important;
      align-items: center !important;
      gap: 10px !important;
      margin-top: 0 !important;
      flex-direction: row !important;
      white-space: nowrap !important;
    }

    .footer-link {
      display: inline-block;
      transition: transform 0.2s ease;
      text-decoration: none;
      line-height: 0;
    }

    .footer-link img {
      width: 24px !important;
      height: 24px !important;
      object-fit: contain !important;
      display: block !important;
    }
  }

  /* --- TABLET/IPAD FOOTER (750px - 991px) --- */
  @media (min-width: 750px) and (max-width: 991px) {
    .landing-footer-section {
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      width: 100% !important;
    }
    
    .landing-footer-section .container-fluid {
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      width: 100% !important;
      max-width: 100% !important;
    }
    
    footer.bg-footer {
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      width: 100% !important;
    }
    
    .landing-footer-section .row {
      justify-content: center !important;
      text-align: center !important;
      width: 100% !important;
      margin: 0 !important;
    }

    .landing-footer-section .col-12 {
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      flex-direction: column !important;
      width: 100% !important;
      padding: 0 !important;
    }

    .footer-container-flex {
      display: flex !important;
      flex-direction: column !important;
      gap: 4px !important;
      padding: 6px 12px !important;
      align-items: center !important;
      justify-content: center !important;
      width: 100% !important;
      max-width: 100% !important;
    }

    .footer-nav {
      display: grid !important;
      grid-template-columns: repeat(3, 1fr) !important;
      gap: 2px 12px !important;
      width: auto !important;
      max-width: 580px !important;
      justify-content: center !important;
      justify-items: center !important;
      align-items: center !important;
      white-space: normal !important;
      padding: 0 !important;
      margin: 0 auto !important;
      text-align: center !important;
      box-sizing: border-box !important;
    }

    .footer-nav a {
      font-size: 12px !important;
      text-align: center !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      padding: 1px 5px !important;
      line-height: 1.1 !important;
      word-wrap: break-word !important;
      word-break: break-word !important;
      hyphens: auto !important;
      min-height: 22px !important;
      overflow-wrap: break-word !important;
      white-space: normal !important;
      width: auto !important;
      margin: 0 !important;
    }

    .footer-separator {
      display: none !important;
    }

    .social-icons-container {
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      width: auto !important;
      margin: 5px auto 0 auto !important;
      gap: 15px !important;
      padding: 5px 0 !important;
      flex-wrap: nowrap !important;
    }

    .footer-link {
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      margin: 0 !important;
    }

    .footer-link img {
      width: 28px !important;
      height: 28px !important;
      object-fit: contain !important;
    }
  }

  /* --- ALL MOBILE DEVICES (Below 750px) - BASE STYLES --- */
  @media (max-width: 749px) {
    .landing-footer-section {
      padding: 0 2px 6px !important;
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      width: 100% !important;
    }

    .landing-footer-section .container-fluid {
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      width: 100% !important;
    }

    .landing-footer-section .row {
      justify-content: center !important;
      text-align: center !important;
      width: 100% !important;
      margin: 0 !important;
    }

    .bg-footer {
      padding: 0 2px 6px !important;
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      width: 100% !important;
    }

    .footer-container-flex {
      flex-direction: column !important;
      gap: 1px !important;
      padding: 0 2px !important;
      align-items: center !important;
      justify-content: center !important;
      display: flex !important;
      width: 100% !important;
    }

    .footer-nav {
      display: grid !important;
      grid-template-columns: repeat(3, 1fr) !important;
      gap: 0 2px !important;
      width: 100% !important;
      max-width: 100% !important;
      justify-content: center !important;
      justify-items: center !important;
      white-space: normal !important;
      padding: 0 !important;
      margin: 0 auto !important;
      text-align: center !important;
      transform: translateY(8px) !important;
    }

    .footer-nav a {
      font-size: 11px !important;
      font-weight: 600 !important;
      text-align: center !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      padding: 0 1px !important;
      line-height: 1 !important;
      word-wrap: break-word !important;
      word-break: break-word !important;
      hyphens: auto !important;
      min-height: 15px !important;
      overflow-wrap: break-word !important;
      white-space: normal !important;
      width: 100% !important;
      margin: 0 !important;
    }

    .footer-separator {
      display: none !important;
    }

    .social-icons-container {
      display: none !important;
      justify-content: center !important;
      align-items: center !important;
      width: 100% !important;
      margin-top: 2px !important;
      gap: 8px !important;
      padding: 2px 0 !important;
      flex-wrap: nowrap !important;
    }

    .footer-link {
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
    }

    .footer-link img {
      width: 20px !important;
      height: 20px !important;
      object-fit: contain !important;
    }
  }

  /* --- Samsung S20 Ultra, S21 Ultra, S22 Ultra (412px - 428px) --- */
  @media (min-width: 412px) and (max-width: 428px) {
    .footer-container-flex {
      padding: 3px 6px !important;
    }

    .footer-nav {
      gap: 1px 3px !important;
      padding: 0 4px !important;
    }

    .footer-nav a {
      font-size: 14px !important;
      padding: 1px 2px !important;
      min-height: 19px !important;
    }

    .social-icons-container {
      gap: 12px !important;
      padding: 0 !important;
    }

    .footer-link img {
      width: 28px !important;
      height: 28px !important;
    }
  }

  /* --- iPhone 12 Pro Max, 13 Pro Max, 14 Plus, 14 Pro Max (428px) --- */
  @media (min-width: 428px) and (max-width: 480px) {
    .footer-container-flex {
      padding: 3px 8px !important;
    }

    .footer-nav {
      gap: 1px 4px !important;
      padding: 0 5px !important;
    }

    .footer-nav a {
      font-size: 12px !important;
      padding: 1px 2px !important;
      min-height: 19px !important;
    }

    .social-icons-container {
      gap: 14px !important;
      padding: 0 !important;
    }

    .footer-link img {
      width: 28px !important;
      height: 28px !important;
    }
  }

  /* --- iPhone 12, 12 Pro, 13, 13 Pro, 14, 14 Pro (390px - 393px) --- */
  @media (min-width: 390px) and (max-width: 411px) {
    .footer-container-flex {
      padding: 3px 5px !important;
    }

    .footer-nav {
      gap: 2px 3px !important;
      padding: 0 3px !important;
    }

    .footer-nav a {
      font-size: 12px !important;
      padding: 1px 2px !important;
      min-height: 18px !important;
    }

    .social-icons-container {
      gap: 10px !important;
      padding: 0 !important;
    }

    .footer-link img {
      width: 26px !important;
      height: 26px !important;
    }
  }

  /* --- iPhone SE, iPhone 8, iPhone 7, iPhone 6s (375px) --- */
  @media (min-width: 375px) and (max-width: 389px) {
    .footer-container-flex {
      padding: 6px 4px !important;
    }

    .footer-nav {
      gap: 2px 2px !important;
      padding: 0 2px !important;
    }

    .footer-nav a {
      font-size: 11px !important;
      padding: 2px 1px !important;
      min-height: 22px !important;
      line-height: 1.05 !important;
    }

    .social-icons-container {
      gap: 8px !important;
      padding: 0 !important;
    }

    .footer-link img {
      width: 24px !important;
      height: 24px !important;
    }
  }

  /* --- iPhone SE 1st Gen, iPhone 5s (320px) --- */
  @media (max-width: 374px) {
    .footer-container-flex {
      padding: 5px 2px !important;
    }

    .footer-nav {
      gap: 1px 1px !important;
      padding: 0 1px !important;
    }

    .footer-nav a {
      font-size: 10px !important;
      padding: 2px 1px !important;
      min-height: 20px !important;
      line-height: 1 !important;
    }

    .social-icons-container {
      gap: 6px !important;
      padding: 0 !important;
    }

    .footer-link img {
      width: 22px !important;
      height: 22px !important;
    }
  }

  /* --- Large Phones (480px - 549px) --- */
  @media (min-width: 480px) and (max-width: 549px) {
    .footer-container-flex {
      padding: 4px 10px !important;
    }

    .footer-nav {
      gap: 1px 5px !important;
      padding: 0 6px !important;
    }

    .footer-nav a {
      font-size: 12.5px !important;
      padding: 1px 3px !important;
      min-height: 20px !important;
    }

    .social-icons-container {
      gap: 14px !important;
      padding: 0 !important;
    }

    .footer-link img {
      width: 28px !important;
      height: 28px !important;
    }
  }

  /* --- Small Tablets / Large Phablets (550px - 749px) --- */
  @media (min-width: 550px) and (max-width: 749px) {
    .footer-container-flex {
      padding: 4px 12px !important;
    }

    .footer-nav {
      gap: 1px 6px !important;
      padding: 0 6px !important;
    }

    .footer-nav a {
      font-size: 12px !important;
      padding: 1px 3px !important;
      min-height: 20px !important;
    }

    .social-icons-container {
      gap: 15px !important;
      padding: 0 !important;
    }

    .footer-link img {
      width: 30px !important;
      height: 30px !important;
    }
  }
`}</style>
      <section
        className="text-center py-1 px-2 landing-footer-section"
        style={{ backgroundColor: "#eff1f1" }}
      >
        <footer className="bg-footer text-dark pt-0">
          <div className="container-fluid">
            <div className="row d-flex justify-content-center align-items-center">
              <div className="col-12 footer-container-flex">
                <nav className="footer-nav text-center justify-content-center">
                  <a
                    href="/About#aboutus"
                    className="text-dark mx-2 text-16 md:text-18"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    About Us
                  </a>
                  {isLoggedIn && (
                    <>
                      <span className="footer-separator">|</span>
                      <a
                        href={pricingHref}
                        onClick={handlePricingClick}
                        className="text-dark mx-2 text-16 md:text-18"
                        style={{ cursor: "pointer" }}
                      >
                        Pricing Plan
                      </a>
                    </>
                  )}
                  <span className="footer-separator">|</span>
                  <a
                    href="/About#CPolicy"
                    className="text-dark mx-2 text-16 md:text-18"
                    rel="noopener noreferrer"
                  >
                    Refund & Cancellation
                  </a>
                  <span className="footer-separator">|</span>
                  <a
                    href="/About#Disclaimer"
                    target="_blank"
                    className="text-dark mx-2 text-16 md:text-18"
                    rel="noopener noreferrer"
                  >
                    Disclaimer
                  </a>
                  <span className="footer-separator">|</span>
                  <a
                    href="/About#PrivacyPolicy"
                    className="text-dark mx-2 text-16 md:text-18"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </a>
                  <span className="footer-separator">|</span>
                  <a
                    href="/About#TearmsConditions"
                    target="_blank"
                    className="text-dark mx-2 text-16 md:text-18"
                    rel="noopener noreferrer"
                  >
                    Terms & Conditions
                  </a>
                  <span className="footer-separator">|</span>
                  <a
                    href="/About#ipr-el"
                    className="text-dark mx-2 text-16 md:text-18"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    IPR & Copyright
                  </a>
                  <span className="footer-separator">|</span>
                  <a
                    href="/About#Contact"
                    className="text-dark mx-2 text-16 md:text-18"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Contact Us
                  </a>

                  <>
                    <span className="footer-separator">|</span>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleClick();
                      }}
                      className="text-dark mx-2 text-16 md:text-18"
                      style={{ cursor: "pointer" }}
                    >
                      Raise Your Concern
                    </a>
                    {/* <a
                      // href="/view-tickets"
                      // href={
                      //   userData && userData?.contact_number
                      //     ? "createTicket"
                      //     : "/create-ticket"
                      // }
                      style={{ cursor: "pointer" }}
                      onClick={handleClick}
                      className="text-dark mx-2 text-16 md:text-18"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Raise Your Concern
                    </a> */}
                  </>
                </nav>

                <div className="social-icons-container">
                  {/* <a
                    href="https://wa.me/9289440049"
                    target="_blank"
                    className="footer-link"
                    rel="noopener noreferrer"
                  >
                    <img src="images/WApp_icon.png" alt="WhatsApp" />
                  </a> */}
                  {/* <a
                    href="https://www.facebook.com/docmasterin/"
                    target="_blank"
                    className="footer-link"
                    rel="noopener noreferrer"
                  >
                    <img src="/images/fb.png" alt="Facebook" />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/78317523/admin/dashboard/"
                    target="_blank"
                    className="footer-link"
                    rel="noopener noreferrer"
                  >
                    <img src="/images/li.png" alt="LinkedIn" />
                  </a>
                  <a
                    href="https://www.instagram.com/docmaster_in/"
                    target="_blank"
                    className="footer-link"
                    rel="noopener noreferrer"
                  >
                    <img src="/images/Instagram.png" alt="Instagram" />
                  </a>
                  <a
                    href="https://x.com/Docmaster_in"
                    target="_blank"
                    className="footer-link"
                    rel="noopener noreferrer"
                  >
                    <img src="/images/twitter.png" alt="Twitter" />
                  </a>
                  <a
                    href="https://youtube.com/@mydocmaster"
                    target="_blank"
                    className="footer-link"
                    rel="noopener noreferrer"
                  >
                    <img src="/images/yt.png" alt="YouTube" />
                  </a> */}
                </div>
              </div>
            </div>
          </div>
        </footer>
      </section>
      {data.showPopUp && (
        <Popup
          title=""
          minHeight="200px"
          maxWidth="500px"
          jsustifyContent="center"
          onClose={() =>
            setData({
              showPopUp: false,
              option: "",
              contactNumber: "",
            })
          }
        >
          {data.option === "" ? (
            <>
              <h2
                style={{
                  marginBottom: "16px",
                  fontSize: "18px",
                  textAlign: "center",
                }}
              >
                Are you a registered user?
              </h2>

              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <button
                  style={buttonStyle}
                  onClick={() =>
                    setData((prev) => ({
                      ...prev,
                      option: "yes",
                      contactNumber: "",
                    }))
                  }
                >
                  Yes
                </button>

                <button
                  style={buttonStyle}
                  onClick={() =>
                    setData((prev) => ({
                      ...prev,
                      option: "no",
                      contactNumber: "",
                    }))
                  }
                >
                  No
                </button>
              </div>
            </>
          ) : (
            <>
              <label>
                <strong>
                  {data.option === "yes"
                    ? "Enter your registered mobile number"
                    : "Enter your mobile number"}
                </strong>
              </label>

              <input
                type="text"
                value={data.contactNumber}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, ""); // allow only 0–9

                  if (value.length <= 10) {
                    setData((prev) => ({
                      ...prev,
                      contactNumber: value,
                    }));
                  }
                }}
                inputMode="numeric"
                placeholder="Enter 10-digit mobile number"
                style={{
                  display: "block",
                  width: "100%",
                  padding: "8px",
                  marginTop: "8px",
                }}
              />

              <button
                style={{ ...buttonStyle, marginTop: "16px" }}
                onClick={async () => {
                  if (data.contactNumber?.length === 10) {
                    const mobile_number = data?.contactNumber;
                    const response = await dispatch(
                      getuserIdByPhoneNumber(mobile_number),
                    );
                    console.log("response", JSON.stringify(response));
                    const userId = response?.payload?.user
                      ? response?.payload?.user?.id
                      : "";
                    const email = response?.payload?.user
                      ? response?.payload?.user?.email
                      : "";
                    console.log(userId); // 56
                    navigate("/create-ticket", {
                      state: {
                        contactNumber: data.contactNumber,
                        userId: userId,
                        email: email,
                      },
                    });
                  } else {
                    alert("Enter the valid mobile number");
                  }
                }}
              >
                Submit
              </button>
            </>
          )}
        </Popup>
      )}
    </>
  );
};

export default Footer;
